import { Link } from 'react-router-dom';

const modes = [
  {
    mode: 'ODM',
    fullName: 'Original Design Manufacturing',
    title: 'ODM 委託設計代工',
    color: '#4CAF50',
    bgColor: '#f0faf0',
    borderColor: '#c8e6c9',
    desc: '由康永生技提供完整的配方設計、原料選擇與產品規格，客戶僅需提供品牌定位與目標訴求，即可獲得完整的代工產品。',
    suitable: '適合剛起步的品牌、想快速推出新品的通路商',
    points: [
      '康永提供現有或客製配方選擇',
      '研發團隊依需求調整配方',
      '包含原料採購、生產、品管全流程',
      '可貼上客戶自有品牌標籤',
      '縮短產品開發時程',
    ],
  },
  {
    mode: 'OEM',
    fullName: 'Original Equipment Manufacturing',
    title: 'OEM 委託製造代工',
    color: '#2e7d32',
    bgColor: '#e8f5e9',
    borderColor: '#a5d6a7',
    desc: '客戶提供完整的配方規格與技術文件，由康永生技負責生產製造，確保產品依照客戶要求精準生產，品質穩定一致。',
    suitable: '適合已有配方、想找穩定製造商的成熟品牌',
    points: [
      '客戶提供完整配方與規格',
      '康永依規格進行製造',
      '嚴格品管確保每批品質一致',
      '保密協議保護客戶配方',
      '支援多種劑型與包材規格',
    ],
  },
];

export default function OdmOemSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            合作模式
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            ODM vs OEM，選擇最適合您的模式
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技提供兩種主要合作模式，依據您的需求與品牌發展階段靈活選擇
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {modes.map((m) => (
            <div
              key={m.mode}
              className="rounded-2xl p-8 border-2 transition-all duration-300"
              style={{ backgroundColor: m.bgColor, borderColor: m.borderColor }}
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-6">
                <div>
                  <span
                    className="inline-block text-white font-bold text-[1.375rem] px-5 py-2 rounded-xl mb-3"
                    style={{ backgroundColor: m.color }}
                  >
                    {m.mode}
                  </span>
                  <p className="text-gray-400 text-[0.8125rem]">{m.fullName}</p>
                  <h3 className="text-[#1a2e1a] font-bold text-[1.25rem] mt-2">{m.title}</h3>
                </div>
              </div>

              <p className="text-gray-600 text-[0.9375rem] leading-[1.75] mb-5">{m.desc}</p>

              <div
                className="inline-block text-[0.8125rem] font-medium px-3 py-1.5 rounded-full mb-5"
                style={{ backgroundColor: `${m.color}18`, color: m.color }}
              >
                ✓ {m.suitable}
              </div>

              <ul className="space-y-2.5">
                {m.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-lg" style={{ color: m.color }} />
                    </div>
                    <span className="text-gray-600 text-[0.9375rem] leading-[1.75]">{pt}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-white rounded-2xl p-8 border border-gray-100">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-[#1a2e1a] font-bold text-[1.125rem] mb-2">不確定哪種模式適合您？</h3>
              <p className="text-gray-500 text-[0.9375rem]">歡迎聯絡業務團隊，我們將依您的需求推薦最合適的合作方式。</p>
            </div>
            <Link
              to="/contact/form"
              className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer flex-shrink-0"
            >
              免費諮詢
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
